import React, { useState, useEffect } from "react";
import "../../../css/Customer/Pages/CustomerHomePage/Components/Testimonials.css";
import ArrowLeft from "frontend/Components/DesignSystem/Arrows/ArrowLeft";
import ArrowRight from "frontend/Components/DesignSystem/Arrows/ArrowRight";
import CardReview1 from "frontend/Components/DesignSystem/Cards/CardReview1";
import ImageDirectory from "frontend/HelperFunctions/ImageDirectory";

/**
 * Testimonials component displays a carousel of client or adviser testimonials.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {boolean} [props.isAdviser=false] - If true, shows adviser testimonials; otherwise, shows client testimonials.
 * @returns {JSX.Element} The rendered Testimonials carousel component.
 *
 * @example
 * // Render client testimonials
 * <Testimonials />
 *
 * @example
 * // Render adviser testimonials
 * <Testimonials isAdviser={true} />
 *
 * @description
 * - Renders a horizontally scrollable carousel of testimonial cards.
 * - Supports both client and adviser testimonials, switching based on the `isAdviser` prop.
 * - Includes left/right arrow controls for navigation.
 * - Handles responsive resizing and scroll position adjustment.
 * - Disables navigation arrows when at the start or end of the carousel.
 */
const Testimonials = ({ isAdviser = false }) => {
  const [cardWidth, setCardWidth] = useState(0);
  const [isAtStart, setIsAtStart] = useState(true); // Track if at the first slide
  const [isAtEnd, setIsAtEnd] = useState(false); // Track if at the last slide
  const containerRef = React.useRef(null);
  const cardRef = React.useRef(null);
  const testimonials = [
    {
      name: "Hayley B",
      text: "“Peter has been excellent. We would highly recommend him. He has been so helpful, accommodating, speedy in his work for us and has managed to explain a lot of complexity re our pensions in a way that we feel we really understand. His personal touch of travelling to see us at our home was so nice too. He has been better than we could have asked for - thank you!”",
    },
    {
      name: "Liam T",
      text: "“Peter was extremely attentive and always on hand whenever I needed him. He explained everything clearly and made it an of ease process. Would highly recommend.”",
    },
    {
      name: "Stephen R",
      text: "“Peter was extremely professional, with a personal touch that ensured that you were not just a random number to him.”",
    },
    {
      name: "Nigel B",
      text: "“Peter has been very good to work with. Always giving clear and considered advice personalised to my needs.”",
    },
    {
      name: "Mary P",
      text: "“My previous pension arrangements were unusual and difficult to unravel. Peter Bott did an excellent job and kept me informed all the way. He then arranged a much better option which is now fully in place. I will definitely recommend him given the opportunity.”",
    },

    // {
    //   name: "Alan K",
    //   text: "Peter was easy to speak to, he also explained all issues clearly. There was a lot of information to take in, however it was covered and at no point was it rushed.",
    // },
    // {
    //   name: "Izabela J",
    //   text: "Rahool has kindness, patience and positive attitude I will be delighted to continue recommending him to my friends and family and I look forward to working with him in the future!",
    // },
    // {
    //   name: "Mariusz M",
    //   text: "I was extremely satisfied with how smooth the entire pension plan setup process was. The instructions were clear, and I received excellent support from Peter whenever I had a question. He was quick to respond and provided detailed answers, which made me feel confident that I made the right decision. I especially appreciated the flexibility of the pension plan options and the transparency in communication. Overall, a great experience, and I would definitely recommend this service to others!",
    // },
    // {
    //   name: "Stuart S",
    //   text: "Was very comfortable working with Peter and found his approach attentive without being overly “in your face”. Thought he explained options very clearly and kept up good communication throughout the process. He made a very important life decision less stressful and I was pleased with the outcome.",
    // },
    // {
    //   name: "Morag J",
    //   text: "Peter is extremely helpful and efficient and goes the extra mile to be available and helpful.",
    // },
    // {
    //   name: "Kerry F",
    //   text: "Peter has always provided any advice in an easily understandable format & has always been promptly available when I have a query. I have been very pleased with the service provided",
    // },
    // {
    //   name: "Clive T",
    //   text: "Peter dealt with everything in a very professional and competent way and was always prompt to reply to my many questions no matter how trivial.",
    // },
    // {
    //   name: "Andy W",
    //   text: "“Overall, I found Peter to be professional, friendly, knowledgeable, efficient, and instilled confidents in me that I had done the right thing and made the right choices.  I will definitely be using Rosemount Partners moving forward, and Peter is already putting me in touch with someone from the office that can help me with my mortgage in the near future.  I would definitely recommend Rosemount partners to colleges, family and friends, and especially Peter for pension advice.”",
    // },
    // {
    //   name: "Hayley & Rhys",
    //   text: "“Rosemount Partners Wealth Management provided a great professional service elping us with our mortgage. All my questions were answered efficiently and we were kept up to date by email thought the process.”",
    // },
    // {
    //   name: "Andy W",
    //   text: "“I would definitely recommend Rosemount Partners to colleges,family and friends, and especially Peter for pension advice.”",
    // },
    // {
    //   name: "Jo and James",
    //   text: "“Out mortgage was handled professionally and all steps taken were clearly explained. The Rosemount Partners team was really helpful and we are confident that we got the best deal that we coud even with rising interest rates. We will definitely use Rosemount again when our next deal expires.”",
    // },
    // {
    //   name: "Ayesha A",
    //   text: "“I have been really happy with the service that Rosemount Partners provided. I had complete trust in the team to find me the best mortage rates for me. They were proactive in reaching out to me and keeping me updated, I never had to chase up on anything. I will continue to use Rosemount in the future.”",
    // },
    // {
    //   name: "Natasha S",
    //   text: "“I am really pleased with the proactive approach Rosemount Partners took in obtaining a mortgage for me. They explained the process to me ensuring I understood everything and was happy with each step. I was kept informed throughout and now, after a long search, have a house and a mortgage I am over the moon with.”",
    // },
    // {
    //   name: "First-time buyer, Dorset",
    //   text: "“I would definitely recommend Rosemount partners to college, family and friends and especially Peter for pension advice.”",
    // },
    {
      name: "Stephanie M",
      text: "“I would just like to say how extremely helpful Peter Bott has been in sorting out my Pension. I would happily recommend anyone to use Peter for their pension or financial”",
    },
    {
      name: "Ian S",
      text: "“We couldn't be happier with Peter. We have always felt that there are no shortcuts, and no regulatory steps are skipped. We are happy with our investments, and really happy that there is someone there who can understand and implement our pension income and income tax management requirements.”",
    },
    {
      name: "Fiona P",
      text: "“Peter was a very helpful pension advisor, friendly and made it all easy to understand. Alway answered my emails promptly. I would recommend Peter.”",
    },
  ];
  const AdviserTestimonials = [
    {
      imgSrc: ImageDirectory["Bourne Financial Options"],
      altText:
        "A company logo with the name Bourne in blue text and Financial Options in black text followed by a circle with a pound sign above a hand reaching out.",
      text: "“There are many things I like about Rosemount. The main thing is the people - they are like one big family. Everybody knows everybody and I like that. If I need to meet with any of my colleagues from Rosemount face to face, they are only 40 minutes away (I don't like Zoom or Teams much) and they are never too busy to see or meet with us. If I need to contact Ahmed for any reason, I can be sure he will answer within the hour - usually less time than that! No matter where he is or what time of the day or day of the week it is. There has never been anything our team in Basingstoke have not been able to help me with.”",
      name: "Donna Bourne - Bourne Financial Options",
    },
    {
      imgSrc: ImageDirectory["Needing Advice"],
      altText:
        "A company logo with a blue house with two square widows a door and a triangular roof, with three green steps leading to the house. The text Needing advice in capital letters and blue with a green underline followed by .co.uk and a tag line in blue text stating Your needs ahead of ours.",
      text: "“My favourite thing about Rosemount is the family feel, how easy they are to get in touch with and how proactive they are in helping. They make the process smooth and stress free and their expertise has been a game-changer, especially when navigating complex cases.”",
      name: "Romany - NeedingAdvice.co.uk Ltd",
    },
    {
      imgSrc: ImageDirectory["Marble-logo"],
      altText:
        "Company logo of a purple circle with three out lines, the first is a solid line with the text marble and a diamond in the top right, the second line a lighter purple split into three sections and the third line covers half the circle in purple.",
      text: "“We started with Rosemount as just one adviser and have now grown to a business with 6 advisers and 3 other members of staff. They have helped us grow by supporting us with business advice and always being available if you need any help or support. I would highly recommend Rosemount to an adviser looking to join a supportive network and one where you are treated as an individual, rather than just a number.”",
      name: "Kerry Nash - Marble Financial Planning Ltd",
    },
    {
      imgSrc: ImageDirectory["wpp-logo"],
      altText:
        "Three circles next to each other with a small gap, first is red with W inside, the second is black with P inside and the third is grey with P inside and below says financial services limited.",
      text: "“Since joining the Rosemount family, I have grown my practice from a sole practitioner to now having 5 full time advisors plus 2 administrators with profit and turnover increasing year on year over the last 6 years. This could not have been done without the daily support I receive from the team at Rosemount. The support and guidance has really made the difference and I would say that Rosemount is a great place to be a part of and I’m looking forward to many more successful years.”",
      name: "Michael Welton - WPP Financial Services Limited",
    },
    {
      imgSrc: ImageDirectory["Taylor-james-logo"],
      altText:
        "A rectangular logo in blue and grey, on the left two vertical lines one blue one grey followed by a half and half of blue and grey, the left half has a circle with a knight inside and the right side is grey with a knight in the background faded, the text across the middle reads taylorjames financial services.",
      text: "“Rosemount is a great company to be a part of. The support they have provided me with over the last 10 years has been invaluable in going from a sole trader, to owning my own thriving business.”",
      name: "Toby Keate - Taylor James Financial Services",
    },
    {
      imgSrc: ImageDirectory["Chaterbridge-logo"],
      altText:
        "Company Logo of a red lion followed by company name of Charterbridge Private Financial Planning",
      text: "“From my first meeting with Ahmed early in 2014, I knew there was something very special about Rosemount. It’s not always obvious just what that might be, until I needed a very specific (and totally unexpected type of unwavering support) simply to continue running and growing my business. The collective (and substantial) presence of Ahmed, Iain and Anne, ensured that my one-man-band practice wasn’t going to be pushed around by heavyweight corporate stealth/stupidity. I’ll never forget their kind support, smart commercial accumen and solid encouragement, even though they were extremely busy themselves. I’ve never needed to look back, other than to say thank you. Since then, the new generation… Zac, Callum, Grace, Jess, Hayleigh, Paul, Peter, Luke… to mention just a few… walk the walk in the same way…fulfilling Christine’s promise of exceptional support all those years ago at the outset. Walking the walk is what you do best.Thanks for the last 10 years y’all…it’s been a privilege and pleasure to be a small part of your impressive successes… Bring it on!”",
      name: "Allan Bullock - Charterbridge Private Financial Planning",
    },
    {
      imgSrc: ImageDirectory["SFL-logo"],
      altText:
        "A black box with white text inside reading SFL, which overlap each other, below the box it reads SFL Wealth Management.",
      text: "“At SFL Wealth Management, we have always been hugely impressed with the level of service provided by Rosemount to us a business and to our advisors. We are very proud of the relationship we have and continue to build together. With Rosemount’s positive guidance and support, we have been able to grow our business and expand our advisor and client base, taking our business to the next level. Communication is easy which is very important - we know we can confidently contact Rosemount at any time always receiving a quick, straight forward and friendly response. A great company to work closely with and fantastic advisor support departments who go above and beyond.  Not to mention the great social side of the relationship!”",
      name: "SFL Wealth Management",
    },
  ];

  useEffect(() => {
    /**
     * Updates the width of the testimonial card and adjusts the scroll position.
     *
     * - Retrieves the current width of the card referenced by `cardRef` and updates the state with this value.
     * - If the container is present, calculates the nearest card based on the current scroll position
     *   and snaps the scroll position to align with the nearest card.
     *
     * @function
     * @returns {void}
     */
    const updateCardWidth = () => {
      if (cardRef.current) {
        const newCardWidth = cardRef.current.offsetWidth;
        setCardWidth(newCardWidth);

        // Adjust scroll position to the nearest card when resizing
        if (containerRef.current) {
          const scrollLeft = containerRef.current.scrollLeft;
          const nearestCard = Math.round(scrollLeft / newCardWidth);
          containerRef.current.scrollLeft = nearestCard * newCardWidth;
        }
      }
    };

    updateCardWidth();
    window.addEventListener("resize", updateCardWidth);
    return () => window.removeEventListener("resize", updateCardWidth);
  }, []);

  /**
   * Handles the scroll event for the testimonials container.
   * Updates the state to indicate whether the scroll position is at the start or end of the container.
   *
   * Checks the current scroll position and sets `isAtStart` to true if the container is scrolled all the way to the left,
   * and sets `isAtEnd` to true if the container is scrolled all the way to the right.
   *
   * @function
   * @returns {void}
   */
  const handleScroll = () => {
    if (containerRef.current) {
      const { scrollLeft, scrollWidth, offsetWidth } = containerRef.current;

      // Check if at the start or end
      setIsAtStart(scrollLeft === 0);
      setIsAtEnd(scrollLeft + offsetWidth >= scrollWidth);
    }
  };

  /**
   * Handles the action of scrolling the testimonial cards container to the left by one card width.
   * Decreases the `scrollLeft` property of the container, effectively showing the previous set of cards.
   * Also calls `handleScroll` to update the state of navigation buttons or any other scroll-dependent logic.
   *
   * @function
   * @returns {void}
   */
  const handlePrev = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft -= cardWidth;
      handleScroll(); // Update button states
    }
  };

  /**
   * Handles the action of scrolling the testimonial cards container to the next set of cards.
   * Increases the horizontal scroll position of the container by the width of one card.
   * Also calls `handleScroll` to update the state of navigation buttons after scrolling.
   *
   * @function
   * @returns {void}
   */
  const handleNext = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft += cardWidth;
      handleScroll(); // Update button states
    }
  };

  const currentTestimonials = isAdviser ? AdviserTestimonials : testimonials;

  return (
    <div className="Testimonial-Container">
      <h2>Testimonials</h2>
      <div className="SubTitle">
        See What Our {isAdviser ? "Advisers" : "Clients"} Say About Us
      </div>
      <div className="Testimonials-Carousel">
        <ArrowLeft onClick={handlePrev} disabled={isAtStart} />
        <div
          className="Carousel-Container"
          ref={containerRef}
          onScroll={handleScroll} // Attach scroll listener
        >
          {currentTestimonials.map((testimonial, index) => (
            <div
              key={index}
              ref={index === 0 ? cardRef : null}
              className="Card-Wrapper"
              style={{ flex: "0 0 100%" }}
            >
              {isAdviser ? (
                <CardReview1
                  image={testimonial.imgSrc}
                  altText={testimonial.altText}
                  text={testimonial.text}
                  name={testimonial.name}
                />
              ) : (
                <CardReview1 name={testimonial.name} text={testimonial.text} />
              )}
            </div>
          ))}
        </div>
        <ArrowRight onClick={handleNext} disabled={isAtEnd} />
      </div>
    </div>
  );
};

export default Testimonials;
